import { Component } from '@angular/core';
import { AccountActivityComponent } from './account-activity.component';

@Component({
  selector: 'eid-account-activity-desktop',
  templateUrl: './account-activity.desktop.component.html',
  styleUrls: ['./account-activity.desktop.component.scss']
})
export class AccountActivityDesktopComponent extends AccountActivityComponent {}
